import {
  GET_COMPANIES_WITH_FEED_ACCESS,
  SET_COMPANIES_WITH_FEED_ACCESS,
  SET_SELECTED_COMPANY,
} from 'redux/constants/Company';

export const getCompaniesWithFeedAccess = () => {
  return {
    type: GET_COMPANIES_WITH_FEED_ACCESS,
  };
};

export const setCompaniesWithFeedAccess = (payload) => {
  return {
    type: SET_COMPANIES_WITH_FEED_ACCESS,
    payload,
  };
};

export const setSelectedCompany = (payload) => {
  return {
    type: SET_SELECTED_COMPANY,
    payload,
  };
};
